<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wXrzsD/tc-custom/9781626817487.jpg?1705634331796" alt="This image is the cover for the book Man's Game"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Man's Game
      </h1>
      <p class="bookDescription body article font2">
        <b>A father hunts the serial killer stalking his daughter in this twisted thriller by “one of the best writers of his generation” (<i>The Guardian</i>). </b><br/>  <br/> Jimbo Slade, a drug dealer and prostitute, is also a suspect in a number of rapes and murders in Seattle. He’s outwitted the police and justice system before, but when the brutal killer targets teenager Kathy Baird, her father takes matters into his own hands. Turning the tables, Jack Baird slowly wins Slade’s trust, and soon he finds himself sharing Slade’s lifestyle—cruising the city’s sewers, lying to his family and the cops. He knows he can trust no one—not with the ruthless justice he has planned.<br/>  <br/> “Thornburg is such an accomplished writer and the story so complex that the reader is left with much to ponder . . . Not an easy book to forget.” —<i>Library Journal</i><br/>  <br/> “A chilling tour of society’s sleazy underside.” —<i>Publishers Weekly</i><br/>  <br/> “Gripping.” —<i>Kirkus Reviews</i><br/>  <br/> “A commanding writer of unusual delicacy and power.” —<i>The New Yorker</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Newton Thornburg
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a3a63c2c